<template>
  <v-container class="mb-16">
    <v-dialog
      ref="datePicker"
      v-model="datePicker"
      :return-value.sync="dateRange"
      persistent
      width="290px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="dateRangeText"
          class="mx-5 my-5"
          label="入住日期~退房日期"
          append-icon="mdi-calendar"
          readonly
          hide-details=""
          outlined
          dense
          v-bind="attrs"
          v-on="on"
          @click:append="datePicker = true"
        />
      </template>
      <v-date-picker
        v-model="dateRange"
        range
        :min="new Date().toISOString().slice(0,10)"
        locale="zh"

        color="primary"
      >
        <v-spacer />
        <v-btn
          text
          color="primary"
          @click="datePicker = false"
        >
          取消
        </v-btn>
        <v-btn
          text
          color="primary"

          @click="datePickerSave"
        >
          確認
        </v-btn>
      </v-date-picker>
    </v-dialog>
    <v-row class="mb-4">
      <v-col
        v-for="item in campList"
        :key="item.id"
        cols="12"
        sm="6"
      >
        <v-card
          class=" "
          elevation="2"
        >
          <v-card-title class="font-weight-bold pl-3 py-2 campName">
            {{ item.name }}
          </v-card-title>
          <v-row
            no-gutters
          >
            <v-col
              cols="8"
            >
              <v-img
                :src="item.img"
                class="ma-3"
                aspect-ratio="1"
              />
            </v-col>
            <v-col
              cols="4"
              class="campInfo pa-1"
            >
              <p class="ma-0 mb-2">
                {{ `金額：$${item.price}` }}
                <!-- item.prices[0] -->
              </p>
              <v-checkbox
                v-if="item.nightOut"
                v-model="item.isNightOut"
                class="pa-0 ma-0"
                label="夜衝"
                hide-details=""
              />
              <v-col
                cols="10"
                class="pa-0"
              >
                <v-select
                  v-model="item.orderQuantity"
                  class="mb-2 mt-8"
                  :items="campQuantity(item)"
                  outlined
                  dense
                  hide-details=""
                  @change="orderRoom"
                />
                {{ `剩餘${String(item.empty)}/${item.quantity}帳` }}
              </v-col>
            </v-col>
          </v-row>
          <!-- <div class="d-flex">

        </div> -->
          <v-divider class="mt-3" />
          <v-card-actions>
            {{ item.description }}
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <OrderInfo
      v-if="orderRoomList.length > 0"
      :order-room-list="orderRoomList"
      @reduceOrderQuantity="reduceOrderQuantity"
    />
    <ul class="pt-6">
      <li
        v-for="(item,key) in noticeList"
        :key="key"
        class="mb-2 notice-list"
        v-html="item"
      />
    </ul>
    <!-- <footer class="nav-down">
      <div class="d-flex px-3 py-2 align-center">
        <div >
         <OrderInfo
         :orderRoomList="orderRoomList"
         />
        </div>
        <v-spacer />
        <v-btn
          class="center"
          rounded
          color="primary"
          outlined
        >
          {{ "送出" }}
        </v-btn>
      </div>
    </footer> -->
  </v-container>
</template>

<script>
import OrderInfo from '/src/components/OrderInfo.vue'
// import $ from 'jquery'
import { mapActions } from 'vuex'

export default {
  components: {
    OrderInfo
  },
  props: { orderDate: {
    type: [String],
    default: null } },
  data () {
    return {
      noticeList: [
        '<span>夜衝或其他需求，請在填寫資料的備註著名即可!</span>夜衝請註明帳數。假日當日無夜衝，亦無單獨夜衝，訂位兩天一夜以上，提前一碗入場才算夜衝(加購價概念)。',
        '訂位後會收到預定確認mail<span>訂金匯款完成並回報才算完成訂位程序。</span>',
        '<span>臨時訂位3日內露營，仍需匯完訂金，訂位才算完成。</span>'
      ],
      orderInfoFooter: 'nav-down',
      dialog: true,
      datePicker: false,
      campList: [
        // {
        //   id: 1,
        //   img: 'https://picsum.photos/500/300?image=16',
        //   name: '小閣樓',
        //   price: '3800',
        //   orderQuantity: 2,
        //   quantity: 2,
        //   description:
        //     '全木造露營屋，冬暖夏涼，空間舒適。有大前庭並提供桌椅可以吹式泡茶聊天，非常方便。',
        //   nightOut: false
        // },
        // {
        //   id: 2,
        //   img: 'https://picsum.photos/500/300?image=19',
        //   name: '印地安',
        //   price: '3800',
        //   orderQuantity: 2,
        //   quantity: 2,
        //   description:
        //     '全木造露營屋，冬暖夏涼，空間舒適。有大前庭並提供桌椅可以吹式泡茶聊天，非常方便。',
        //   nightOut: true
        // }
        // {
        //   id: 3,
        //   img: "https://picsum.photos/500/300?image=19",
        //   name: "印地安",
        //   price: "3800",
        //   orderQuantity: 2,
        //   quantity: 2,
        //   description: "全木造露營屋，冬暖夏涼，空間舒適。有大前庭並提供桌椅可以吹式泡茶聊天，非常方便。",
        //   nightOut: true,
        // },
        // {
        //   id: 4,
        //   img: "https://picsum.photos/500/300?image=19",
        //   name: "印地安",
        //   price: "3800",
        //   orderQuantity: 2,
        //   quantity: 2,
        //   description: "全木造露營屋，冬暖夏涼，空間舒適。有大前庭並提供桌椅可以吹式泡茶聊天，非常方便。",
        //   nightOut: true,
        // },
        // {
        //   id: 5,
        //   img: "https://picsum.photos/500/300?image=19",
        //   name: "印地安",
        //   price: "3800",
        //   orderQuantity: 2,
        //   quantity: 2,
        //   description: "全木造露營屋，冬暖夏涼，空間舒適。有大前庭並提供桌椅可以吹式泡茶聊天，非常方便。",
        //   nightOut: true,
        // },
      ],
      dateRange: [this.orderDate, this.$root.moment(this.orderDate).add(1, 'days').format('YYYY-MM-DD')],
      orderRoomList: []
    }
  },
  computed: {
    dateRangeText: {
      get () {
        // return this.selected
        // if (this.dateRange.length < 2) {
        //   // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        //   this.dateRange = [...this.dateRange, this.$root.moment(this.dateRange[0]).add(1, 'days').format('YYYY-MM-DD')]
        // }
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        let dateRange = this.dateRange.sort((x, y) =>
          this.$root.moment().diff(y, 'minutes') - this.$root.moment().diff(x, 'minutes'))
        // this.search()
        return dateRange.join(' ~ ')
      }
    }
  },
  watch: {
    // dateRange () {
    //   debugger
    //   this.search()
    // }
  },
  mounted () {
    this.search()
  },
  methods: {
    ...mapActions('roomOrder', ['ROOM_OVERVIEW']),
    datePickerSave () {
      if (this.dateRange.length < 2) {
        this.dateRange = [...this.dateRange, this.$root.moment(this.dateRange[0]).add(1, 'days').format('YYYY-MM-DD')]
      }
      this.$refs.datePicker.save(this.dateRange)
      this.search()
    },
    async search () {
      let result = await this.ROOM_OVERVIEW({ 'account_id': '@musician703' })
      console.log('result', result)
      if (result) {
        this.campList = result

        this.campList.forEach(element => {
          // 假資料
          element.price = '1200'
          element.empty = 3
          // ----------
          element.orderQuantity = 0
          element.isNightOut = false
        })
        this.orderRoom()
        // this.campList
        // -------------------------
      }
    },
    reduceOrderQuantity (id) {
      this.campList.filter((x) => {
        if (x.id === id) {
          x.orderQuantity -= 1
        }
      })
      this.orderRoom()
      // console.log('campList',this.campList);
    },
    orderRoom () {
      this.orderRoomList = this.campList.filter((x) => x.orderQuantity > 0)
      // if (this.orderRoomList.length > 0) {
      //   $('footer').removeClass('nav-down').addClass('nav-up')
      // } else {
      //   $('footer').removeClass('nav-up').addClass('nav-down')
      // }
      // debugger
    },
    campQuantity (item) {
      // 給預設值
      // debugger
      // if (!item['orderQuantity']) {
      // item['orderQuantity'] = 0
      // debugger
      // item['isNightOut'] = false
      // 假資料
      // setTimeout(() => {
      // }, 1)
      // debugger
      // item['empty'] = 3
      // item['price'] = '1200'
      // ------------------------
      // }
      let arr = []
      for (let index = 0; index < item.empty + 1; index++) {
        arr.push(index)
      }
      return arr
    }
  }
}
</script>

<style scoped>
.campInfo {
  background-color: #e2f5f3;
  border-radius: 0px 0px 0px 8px;
}
footer {
  position: fixed;
  bottom: -1px;
  transition: bottom 0.25s ease-in-out;
  width: 100%;
  box-shadow: 0px -2px 6px 1px #e2dddd;
  padding-bottom: 2.5%;
  left: -1px;
  background-color: white;
  border-top: 1px solid #ddd;
}
.nav-down {
  bottom: -100%;
}
.campName{
  /* width: 95%; */
  background-color: #e2f5f3;

}

  .campInfoBox .v-box{
    width: 50%;
  }
</style>
<style>
.notice-list > span{
  color:red;
  font-weight: bold;
}

</style>
